import React, { useEffect, useState } from "react";
import { MapPin, Building2, ArrowLeft, ArrowRight } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchStates,
  fetchDistricts,
} from "../../../../features/master/masterThunks";

import { fetchBookletDetail, bookBookletSlots } from "../../../../features/booklet/bookletThunks";
import { clearBooklet } from "../../../../features/booklet/bookletSlice";
import { createCashPayment,} from "../../../../features/payment/paymentThunks";
import BookletSlotModal from "./BookingModal";
import PaymentOptionModal from "../pyment/PaymentOption";
import PaymentQRModal from "../pyment/PaymentQRModal";
import useOnlinePayment from "../../../../hooks/useOnlinePayment";
import { loginMerchant } from "../../../../features/merchant/merchantThunks";
import api from "../../../../api/axiosInstance";
import useCashPayment from "../../../../hooks/useCashPayment";
import "./Booklet.css";
const Booklet = () => {const dispatch = useDispatch();

  const { states, districts } = useSelector((state) => state.master);
  const { booklet, pages, loading } = useSelector((state) => state.booklet);

  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);

  // pyment 
const [selectedSlotForPayment, setSelectedSlotForPayment] = useState(null);
const [paymentOpen, setPaymentOpen] = useState(false);
const [bookingData, setBookingData] = useState(null);
const [qrData, setQrData] = useState(null);
const { startOnlinePayment } = useOnlinePayment();

const {cashPaymentData, status, payment_status, closePayment,} = useCashPayment({
  autoReload: true, // reload after success
});


  // ----------------------------------------------------
  // Load States on Mount
  // ----------------------------------------------------
  useEffect(() => {
    dispatch(fetchStates("68e8ef76a65b0a7d7ec75a29")); // countryId
  }, []);

  // ----------------------------------------------------
  // Load Districts when State changes
  // ----------------------------------------------------
  useEffect(() => {
    if (stateId) {
      dispatch(fetchDistricts(stateId));
    }
  }, [stateId]);


  // ----------------------------------------------------
  // Fetch Booklet based on State/District
  // ----------------------------------------------------
  useEffect(() => {
    if (stateId && districtId) {
      dispatch(fetchBookletDetail({ stateId, districtId }));
    } else {
      dispatch(clearBooklet()); // clear old data
    }

    setCurrentPage(0);
  }, [stateId, districtId]);


const handleBookNowClick = async (slot, paymentType, chosenAmount) => {
  setModalOpen(false);

  const result = await dispatch(
    bookBookletSlots({
      bookletId: booklet?.id,
      slots: [
        {
          pageNo: safePages[currentPage]?.pageNo,
          bookedPositions: [slot.position],
        },
      ],
    })
  );

  if (bookBookletSlots.fulfilled.match(result)) {
    const bookingId = result.payload.bookingId;
    setSelectedSlotForPayment({
      ...slot,
      bookingId,
      paymentType: paymentType || "full",
      paymentAmount: chosenAmount || slot.totalAmount,
    });
    setPaymentOpen(true);
  }
};


const handlePaymentSelect = async (method) => {
  const payAmount = selectedSlotForPayment?.paymentAmount || selectedSlotForPayment?.totalAmount;
  const isPartial = selectedSlotForPayment?.paymentType === "partial";

  // ---------------- CASH PAYMENT ----------------
  if (method === "cash") {
    try {
      const result = await dispatch(
        createCashPayment({
          bookingId: selectedSlotForPayment.bookingId,
          amount: payAmount,
          paymentFor: "booklet",
          isPartialPayment: isPartial,
        })
      );

      if (!createCashPayment.fulfilled.match(result)) {
        alert("Failed to create cash payment");
        return;
      }

      setPaymentOpen(false);
    } catch (err) {
      console.error("Cash payment error:", err);
      alert("Something went wrong. Please try again.");
    }

    return;
  }

  // ---------------- ONLINE PAYMENT (RAZORPAY) ----------------
  if (method === "online") {
    setPaymentOpen(false);

    startOnlinePayment({
      bookingId: selectedSlotForPayment.bookingId,
      amount: payAmount,
      paymentFor: "booklet",
      isPartialPayment: isPartial,

      onSuccess: (response) => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },

      onFailure: (message) => {
        console.error("Online payment failed:", message);
        alert(message || "Payment failed. Please try again.");
      },
    });
  }
};

  // ----------------------------------------------------
  // Safe fallback values
  // ----------------------------------------------------
  const safePages = pages || [];
  const totalPages = safePages.length;
  const currentSlots = safePages[currentPage]?.positions || [];

  const nextPage = () =>
    currentPage < totalPages - 1 && setCurrentPage(currentPage + 1);

  const prevPage = () =>
    currentPage > 0 && setCurrentPage(currentPage - 1);

  return (
    <div className="booklet-container">
      <h3 className="booklet-title">Advertisement Collective Module</h3>

      {/* ------------------------------------------- */}
      {/* LOCATION FILTERS */}
      {/* ------------------------------------------- */}
      <div className="row g-3 mb-3">
        {/* State */}
        <div className="col-md-6">
          <div className="dropdown-box">
            <MapPin className="drop-icon" />
            <select
              className="form-select drop-select"
              value={stateId}
              onChange={(e) => {
                setStateId(e.target.value);
                setDistrictId("");
              }}
            >
              <option value="">Select State</option>
              {states.map((st) => (
                <option key={st._id} value={st._id}>
                  {st.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* District */}
        <div className="col-md-6">
          <div className="dropdown-box">
            <Building2 className="drop-icon" />
            <select
              className="form-select drop-select"
              value={districtId}
              onChange={(e) => {
                setDistrictId(e.target.value);
              }}
            >
              <option value="">Select District</option>
              {districts.map((d) => (
                <option key={d._id} value={d._id}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <p className="text-center py-5">Loading Booklet...</p>
      ) : !booklet ? (
        <p className="text-center py-5 text-danger">
          No Collective advertisement Slots available for this State / District.
        </p>
      ) : (
        <>
          {/* PAGE INFO & PROGRESS */}
          <div className="page-info">
            Page {currentPage + 1} of {totalPages}
            <div className="progress-bar-wrapper">
              <div
                className="progress-bar-filled"
                style={{
                  width:
                    totalPages > 0
                      ? `${((currentPage + 1) / totalPages) * 100}%`
                      : "0%",
                }}
              ></div>
            </div>
          </div>

          {/* PAGE CARD */}
          <div className="page-card">
            {/* <div className="page-header">
              📘 {safePages[currentPage]?.pageTitle}
            </div> */}

            {/* Dynamic slot grid class based on number of slots */}
          <div
  className={`slot-grid ${
    currentSlots.length === 1
      ? "slots-1"
      : currentSlots.length === 2
      ? "slots-2"
      : currentSlots.length <= 4
      ? "slots-lg"
      : currentSlots.length <= 6
      ? "slots-md"
      : "slots-sm" }`}>
              {currentSlots.map((slot) => (
                <div
                  key={slot.position}
                  className={`slot-card ${
                    slot.isSlotBooked ? "booked" : "open"
                  }`}
                  onClick={() => {
                    if (!slot.isSlotBooked) {
                      setSelectedSlot(slot);
                      setModalOpen(true);
                    }
                  }}
                >
                  {slot.isSlotBooked ? (
                    <>
                      <div className="slot-icon-booked">✔</div>
                      <div className="slot-booked-text">Booked</div>
                      <div className="slot-price">₹ {slot.amount}</div>
                    </>
                  ) : (
                    <>
                      <div className="slot-icon-open">+</div>
                      <div className="slot-open-pos">
                        Position {slot.position}
                      </div>
                      <div className="slot-price">₹ {slot.amount}</div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* PAGINATION */}
          <div className="pagination-controls">
            <button
              className="nav-btn"
              onClick={prevPage}
              disabled={currentPage === 0}
            >
              <ArrowLeft />
            </button>

            <div className="dots">
              {safePages.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${i === currentPage ? "active" : ""}`}
                ></span>
              ))}
            </div>

            <button
              className="nav-btn"
              onClick={nextPage}
              disabled={currentPage === totalPages - 1}
            >
              <ArrowRight />
            </button>
          </div>
        </>
      )}
      {/* SLOT MODAL */}
      <BookletSlotModal
  show={modalOpen}
  onClose={() => setModalOpen(false)}
  slot={selectedSlot}
  pageNo={safePages[currentPage]?.pageNo}
  onBookClick={handleBookNowClick}
/>
<PaymentOptionModal
  open={paymentOpen}
  onClose={() => setPaymentOpen(false)}
  onSelect={handlePaymentSelect}
/>
<PaymentQRModal
  open={Boolean(cashPaymentData)}
  data={cashPaymentData}
  status={status}
  payment_status={payment_status}
  onClose={closePayment}
/>
    </div>
  );
};
export default Booklet;
